/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { MerchantSearchResult } from './MerchantSearchResult';
import {
    MerchantSearchResultFromJSON,
    MerchantSearchResultFromJSONTyped,
    MerchantSearchResultToJSON,
    MerchantSearchResultToJSONTyped,
} from './MerchantSearchResult';

/**
 * 
 * @export
 * @interface SearchMerchantsResponse
 */
export interface SearchMerchantsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof SearchMerchantsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<MerchantSearchResult>}
     * @memberof SearchMerchantsResponse
     */
    merchants: Array<MerchantSearchResult>;
}

/**
 * Check if a given object implements the SearchMerchantsResponse interface.
 */
export function instanceOfSearchMerchantsResponse(value: object): value is SearchMerchantsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('merchants' in value) || value['merchants'] === undefined) return false;
    return true;
}

export function SearchMerchantsResponseFromJSON(json: any): SearchMerchantsResponse {
    return SearchMerchantsResponseFromJSONTyped(json, false);
}

export function SearchMerchantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchMerchantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'merchants': ((json['merchants'] as Array<any>).map(MerchantSearchResultFromJSON)),
    };
}

export function SearchMerchantsResponseToJSON(json: any): SearchMerchantsResponse {
    return SearchMerchantsResponseToJSONTyped(json, false);
}

export function SearchMerchantsResponseToJSONTyped(value?: SearchMerchantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'merchants': ((value['merchants'] as Array<any>).map(MerchantSearchResultToJSON)),
    };
}

